import token from "./serialize-token";

const defaultFontFamily = [
    "'Roboto'",
    "'Cordia New'",
    "'Microsoft Sans Serif'",
    "'Utsaah'",
    "'Devanagari MT'",
    "'Nirmala UI'",
    "'Latha'",
    "'InaiMathi'",
    "'Gautami'",
    "'Telugu Sangam MN'",
    "'Tunga'",
    "'Kannada Sangam MN'",
    "'Kartika'",
    "'Malayalam Sangam MN'",
    "'Shruti'",
    "'Nirmala UI'",
    "'Gujarati MT'",
    "'Gujarati Sangam MN'",
    "'Vrinda'",
    "'Bangla Sangam MN'",
    "'Meiryo UI'",
    "'メイリオ'",
    "'MS UI Gothic Reg'",
    "'Hiragino Kaku Gothic Reg'",
    "'ヒラギノ角ゴ Pro W3 Reg'",
    "'Microsoft YaHei'",
    "'微软雅黑'",
    "'Hiragino Sans GB'",
    "'Microsoft JhengHei'",
    "'微軟正黑體'",
    "'Malgun Gothic'",
    "'맑은 고딕'",
    "'Gulim'",
    "'AppleGothic'",
    "'Apple LiGothic'",
    "'LiHei Pro'",
    "'Osaka'",
    "'STHeiti'",
    "'华文黑体'",
    "'STXihei'",
    "'华文细黑'",
    "'SimHei'",
    "'黑体'",
    "'Arial Unicode MS'",
    "'Arial'",
    "'sans-serif'",
];

const monospaceFontFamily = [
    "'sfmono-regular'",
    "'menlo'",
    "'monaco'",
    "'consolas'",
    "'Liberation Mono'",
    "'Courier New'",
    "'monospace'",
];

export default {
    "font-family-base": token(defaultFontFamily.join(", ")),
    "font-family-monospace": token(monospaceFontFamily.join(", ")),
    // Font-weights
    "font-weight-light": token("300"),
    "font-weight-normal": token("400"),
    "font-weight-medium": token("500"),
    "font-weight-bold": token("700"),
    "font-weight-base": token("400"),
    // Font-sizes
    "font-size-0": token("0.75rem"),
    "font-size-1": token("1rem"),
    "font-size-2": token("1.25rem"),
    "font-size-3": token("1.5rem"),
    "font-size-4": token("1.75rem"),
    "font-size-5": token("2rem"),
    "font-size-6": token("2.25rem"),
    "font-size-7": token("2.5rem"),
    "font-size-8": token("2.75rem"),
    "font-size-9": token("3rem"),
    "font-size-10": token("3.25rem"),
    "font-size-11": token("3.5rem"),
    "font-size-12": token("3.75rem"),
    "font-size-13": token("4rem"),
    "font-size-14": token("4.25rem"),
    "font-size-15": token("4.5rem"),
    // Line-height
    "line-height-0": token("1rem"),
    "line-height-1": token("1.25rem"),
    "line-height-2": token("1.5rem"),
    "line-height-3": token("1.75rem"),
    "line-height-4": token("2rem"),
    "line-height-5": token("2.25rem"),
    "line-height-6": token("2.5rem"),
    "line-height-7": token("2.75rem"),
    "line-height-8": token("3rem"),
    "line-height-9": token("3.25rem"),
    "line-height-10": token("3.5rem"),
    "line-height-11": token("3.75rem"),
    "line-height-12": token("4rem"),
    "line-height-13": token("4.25rem"),
    "line-height-14": token("4.5rem"),
    "line-height-15": token("4.75rem"),
    "line-height-16": token("5.5rem"),
};
